// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2G3a_","rightAdornment":"Header_rightAdornment__3TI5H"};